import { render, staticRenderFns } from "./NavigationDesktop.vue?vue&type=template&id=093b54f2&"
import script from "./NavigationDesktop.vue?vue&type=script&lang=js&"
export * from "./NavigationDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports